import { Component } from '@angular/core';
import { BreadcrumbService } from './breadcrumb.service';


@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent {
  get breadcrumbs() {
    return this.breadcrumbService.breadcrumbs;
  }

  constructor(
    private breadcrumbService: BreadcrumbService,
  ) {
  }

  get isBreadcrumbHidden(): boolean {
    return this.breadcrumbService.isTitleHidden;
  }

}
